<template>
    <div class="rounded p-20 bg-green-800"><slot></slot></div>
</template>